// client/src/routes/app/settings/profile.tsx — SCR-SET-001 „Profilul meu" · AUTH-004.

import { createFileRoute } from '@tanstack/react-router';

import { ProfileScreen } from '@/features/settings/ProfileScreen';

export const Route = createFileRoute('/app/settings/profile')({
  component: ProfileScreen,
});
